import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { Subject } from 'rxjs';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { chooseOptionsConstant } from 'src/app/constants/service.constants';
import { GridApi } from 'ag-grid-community';
import { EditAndDeleteOperationsRenderer } from 'src/app/common/client-grid/edit-and-delete-operations.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { ConfigureTemplateViewComponent } from './configure-template-view/configure-template-view.component';
import { DeleteBoxComponent } from '../../delete-box/delete-box.component';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'configure-template-modal',
  templateUrl: './configure-template-modal.component.html',
  styleUrls: ['./configure-template-modal.component.scss']
})
export class ConfigureTemplateModalComponent implements OnInit {
  @Input() public  Content : any ;
  content: any;
  action: Subject<any> = new Subject();
  heading: string;
  columnDefs; 
  operations: any[];
  tempoperations: any[];
  gridApi: GridApi;
  rowData;
  context;
  gridOptions;
  frameworkComponents;
  loadGrid = false;
  ApplicationID: any;
  PatientID: any;
  selectedRow: any;
  constructor(
    private summaryService: IstSummaryService,
    public mRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonservice: CommonService
  ) {

    this.columnDefs = [
       {
        "headerName": "Document Templates",
        "field": "TEMPLATE_NAME"
      },
      {
        "headerName": "Application Type",
        "field": "MappedAppTypesNames"
      },
      {
        "headerName": "Applicable Screens",
        "field": "SCREEN_ID"
      }
    ]
     this.tempoperations = [
      {
        "name": "Edit",
        "id": "Edit"
      },
      {
        "name": "Delete",
        "id": "Delete"
      }
    ]; 
   /*  this.tempoperations = [ ];
    if(this.commonservice.getScreenPermission("624","E")){
      this.tempoperations.push({
        "name": "Edit",
          "id": "Edit"
      });
    }
    if(this.commonservice.getScreenPermission("624","D")){
      this.tempoperations.push({
        "name": "Delete",
          "id": "Delete"
      });
    } */

    this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }

    this.context = { componentParent: this };

    this.frameworkComponents = {
      deleteRenderer: EditAndDeleteOperationsRenderer
    };

  }

  onGridReady(params) {
    this.gridApi = params.api;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }

  ngOnInit() {
    this.getSummary();
    setTimeout(() => {
      this.loadGrid = true;
    }, 350);

  }
  getSummary() {
    this.summaryService.getSummaryData("api/ISTFileAttachments/GetSummaryScreenTemplates?ScreenID=" + this.Content.content.MODULE_ID + "&SUB_MODULE=" + this.Content.content.SUB_MODULE).subscribe(result => {
      this.rowData = result;
      document.body.click();
      setTimeout(() => {
        this.loadGrid = true;
      }, 350);
    });
  }
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback(this.summaryService);
  }
  Delete(RcordData:any) {
    let id = RcordData['ID'];   //this.selectedRow['ID'];
    let name=RcordData['TEMPLATE_NAME'];
    var modalRef=  this['self'].modalRef = this['self'].modalService.open(DeleteBoxComponent, 
      {backdrop: false});
      modalRef.componentInstance.Content=
      { heading: 'Delete Document Template', 
      custommessage: 'Are you sure you want to delete the Document Template ' + "'" + name + "'" + '?',
      ProceedButtonName:"Delete", TerminateButtonName:"Cancel"}
      modalRef.result.then(result => {
      if(result=="okclick")
      {
      this["self"].summaryService.DeleteRecord('api/ISTFileAttachments/Delete?TemplateId=' + id).subscribe(summary => {
        if (summary["Status"] == 0) {
          this["self"].commonservice.SuccessBanner(summary.Message);
          this["self"].getSummary();
        }
        else {
          this["self"].commonservice.ValidationBanner("Error Occured while deleting records");
          //this["self"].commonservice.SuccessBanner("Error Occured while deleting records.");

        }
      });
    }
    })
  }
  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }
  Edit(RcordData:any) {
    let modalRef = this['self'].modalService.open(ConfigureTemplateViewComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
     
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: RcordData['ID'], MODULE_ID: this['self'].Content.content.MODULE_ID,SUB_MODULE: this['self'].Content.content.SUB_MODULE }
    }
    modalRef.result.then(result => {
      this['self'].getSummary();
    });
  }
  ClosePopup() {
    
    this.mRef.close();
  }

  onRowDoubleClicked(event) {
    let modalRef = this.modalService.open(ConfigureTemplateViewComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'View',
      content: { id: event.data['ID'], MODULE_ID: this.Content.content.MODULE_ID}

    }
    modalRef.result.then(result => {
      this.getSummary();
    });
  }
  addLabDetail() {
     ;
    let modalRef = this.modalService.open(ConfigureTemplateViewComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: "", MODULE_ID: this.Content.content.MODULE_ID, SUB_MODULE: this.Content.content.SUB_MODULE}
    }
    modalRef.result.then(result => {
      this.getSummary();
    });
  }
}
